import script from "./serving-size-category-list.vue?vue&type=script&setup=true&lang=js"
export * from "./serving-size-category-list.vue?vue&type=script&setup=true&lang=js"

import "./serving-size-category-list.vue?vue&type=style&index=0&id=6712c863&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6712c863"]])

export default __exports__